"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncUiThemesResponse = exports.DEFAULT_UI_THEME_ID = exports.UiThemeAvailable = exports.UiTheme = exports.UiThemeInput = exports.UiThemePalette = exports.UiThemeId = void 0;
const zod_1 = require("zod");
/** RL-311 / RL-312: data-only palettes for the opted-in standard customer UI. */
exports.UiThemeId = zod_1.z.string().regex(/^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$/);
exports.UiThemePalette = zod_1.z
    .object({
    brand: zod_1.z.string().regex(/^#[0-9a-fA-F]{6}$/),
    accent: zod_1.z.string().regex(/^#[0-9a-fA-F]{6}$/),
    surface: zod_1.z.string().regex(/^#[0-9a-fA-F]{6}$/),
})
    .strict();
exports.UiThemeInput = zod_1.z
    .object({
    name: zod_1.z.string().trim().min(1).max(120),
    light: exports.UiThemePalette,
    dark: exports.UiThemePalette,
})
    .strict();
exports.UiTheme = exports.UiThemeInput.extend({
    id: exports.UiThemeId,
    kind: zod_1.z.enum(['preset', 'custom']),
});
exports.UiThemeAvailable = zod_1.z
    .array(exports.UiThemeId)
    .min(1)
    .max(32)
    .refine((ids) => new Set(ids).size === ids.length, 'Theme IDs must be unique');
exports.DEFAULT_UI_THEME_ID = 'reform';
/** Upserts are idempotent; deletes include availability removals, not just archives.
 * A cursor-less/snapshot pull starts a cache replacement. Keep all subsequent
 * pages in the same reconciliation, commit each page and cursor atomically.
 * A changed allow-list may resend unchanged documents. Never merge cursor-less
 * snapshots into an old cache, or compare opaque cursors on the client.
 */
exports.SyncUiThemesResponse = zod_1.z
    .object({
    items: zod_1.z.array(zod_1.z.discriminatedUnion('kind', [
        zod_1.z.object({ kind: zod_1.z.literal('upsert'), id: exports.UiThemeId, payload: exports.UiTheme }).strict(),
        zod_1.z.object({ kind: zod_1.z.literal('delete'), id: exports.UiThemeId }).strict(),
    ])),
    cursor: zod_1.z.string().min(1),
    hasMore: zod_1.z.boolean(),
    snapshotAt: zod_1.z.string().datetime(),
})
    .strict()
    .superRefine((response, ctx) => {
    response.items.forEach((item, index) => {
        if (item.kind === 'upsert' && item.id !== item.payload.id)
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                path: ['items', index, 'payload', 'id'],
                message: 'Theme delta ID must match its payload',
            });
    });
});
//# sourceMappingURL=ui-theme.js.map